function SelectOptionsToRoles(roles) {
	var selectedOptions = roles.map(function (o) {			
		return {id: parseInt(o.value), name: o.label}
	});		
	return selectedOptions;    
}
export default SelectOptionsToRoles;